import gql from 'graphql-tag'
import {getCounterpartyId} from '../../../services/authService'
import {getConfigBaseUrl} from '../../../services/apiService'

export const getClientRankingHistoryByClientQuery = (clientId: string) => {
	return `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/clients/${clientId}/ranking-history`
}

export const getClientRankingHistoryQuery = (fromDate: string, toDate: string, clientIds?: string[]) => {
	const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/clients/ranking-history?fromDate=${fromDate}&toDate=${toDate}`
	if (!clientIds) return url
	return `${url}&clientIds=${clientIds.join(',')}`
}

export const getMyClientsQuery = gql`
	query {
		allClients(tenantId: "${getCounterpartyId()}") {
			tenantId
			clientId
			isActive
			fullName
			shortName
			legalEntityExternalId
			externalProviderRefId
			clientRanking
			clientType
			internalCreditRating
			country
			orgId
			entityType
			entitySubType
			relationships
      internalCode1
      internalCode2
      internalCode3
      internalCode4
      internalCode5
			limits {
				clientLimitsId
				id
				limitsCategory
				limitsType
				assetType
				limitsValue
				expiry
			}
			durationLimits {
				durationLimitsId
				id
				assetType
				days
				expiry
			}
      agreementTypes
      clientTypeDesc
			properties {
				propertyId
				id
				agreementType
				propertyKey
				propertyValue
				propertyDataType
			}
		}
	}
`
